/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1AppsGetAppRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
};

/** @internal */
export type V1AppsGetAppRequestBody$Outbound = {
  project: string;
  app: string;
};

/** @internal */
export const V1AppsGetAppRequestBody$outboundSchema: z.ZodType<
  V1AppsGetAppRequestBody$Outbound,
  z.ZodTypeDef,
  V1AppsGetAppRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
});

export function v1AppsGetAppRequestBodyToJSON(
  v1AppsGetAppRequestBody: V1AppsGetAppRequestBody,
): string {
  return JSON.stringify(
    V1AppsGetAppRequestBody$outboundSchema.parse(v1AppsGetAppRequestBody),
  );
}
